import { DialogMemberViewModel } from '@common/model/dialog/dialogMemberViewModel';
import { useMemo } from 'react';
import { useSelector, useStore } from 'react-redux';
import { EntityId } from '@reduxjs/toolkit';
import { currentDialogIdSelector } from './store/currentDialogSelectors';
import { currentDialogMemberSelector } from './store/selectors';
import { useCurrentUserContext } from './user.ctx';

export const useCurrentDialogMember = (props: { dialogId?: EntityId } = {}): DialogMemberViewModel | undefined => {
  const store = useStore();
  const provider = useCurrentUserContext();
  const currentDialogId = useSelector(currentDialogIdSelector);
  const dialogId = props.dialogId ?? currentDialogId;
  const user = provider.getUser();

  return useMemo(() => {
    return user && dialogId ? currentDialogMemberSelector(store.getState(), { dialogId, user }) : undefined;
  }, [store, user, dialogId]);
};
